module.exports = __webpack_public_path__ + "static/media/PP_2019 PPbag.ad7190d6.png";